import { render, staticRenderFns } from "./orderCountByHour.vue?vue&type=template&id=54b5d308&"
import script from "./orderCountByHour.vue?vue&type=script&lang=js&"
export * from "./orderCountByHour.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports